import { Button, Grid, Typography, useMediaQuery, Box } from '@mui/material';
import useTranslations from '../global/translation/hooks/translation';
import { useTheme } from '@mui/material/styles';
import { useThemeContext } from '../global/ThemeContext';

const Mission = () => {
  const { currentLanguage, translations } = useTranslations();
  const theme = useTheme();
  const { darkMode } = useThemeContext();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const heroText = translations.label.heroText[currentLanguage];
  const heroSubtext = translations.label.heroSubtext[currentLanguage];
  const buttonText = translations.label.ctaApplyTraining[currentLanguage];

  return (
    <Grid
      container
      color={theme.palette.text.primary}
      sx={{
        bgcolor: darkMode ? '#232323' : '#F9F9F9',
      }}
      justifyContent="center"
    >
      <Grid
        item
        pt={isMobile ? 6 : 10}
        pb={isMobile ? 8 : 16}
        px={isMobile ? 3 : '4rem'}
        xs={12}
        sx={{
          maxWidth: '900px',
          textAlign: 'center',
        }}
      >
        {/* Main Hero Headline */}
        <Typography
          variant={isMobile ? 'h5' : 'h3'}
          fontWeight={300}
          sx={{
            color: darkMode ? '#FFFFFF' : '#000000',
            lineHeight: 1.4,
            mb: 2,
            letterSpacing: '-0.5px',
          }}
        >
          {heroText}
        </Typography>

        {/* Scarcity Signal */}
        <Typography
          variant="caption"
          sx={{
            color: theme.palette.text.secondary,
            display: 'block',
            mb: 4,
            textTransform: 'uppercase',
            letterSpacing: '1px',
            fontWeight: 500,
          }}
        >
          {heroSubtext}
        </Typography>

        {/* CTA Button */}
        <Box sx={{ textAlign: 'center' }}>
          <Button
            size="large"
            variant="contained"
            sx={{
              mt: 2,
              bgcolor: theme.palette.primary.main,
              color: darkMode ? '#FFFFFF' : '#FFFFFF',
              fontWeight: 600,
              borderRadius: '4px',
              px: 4,
              py: 1.8,
              fontSize: '16px',
              letterSpacing: '0.3px',
              textTransform: 'none',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              boxShadow: 'none',
              '&:hover': {
                bgcolor: theme.palette.primary.dark,
                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
                transform: 'translateY(-2px)',
              },
              '&:active': {
                transform: 'translateY(0)',
              },
              '&:focus': {
                outline: `2px solid ${theme.palette.primary.main}`,
                outlineOffset: '2px',
              },
            }}
            onClick={() => (window.location.href = 'https://lubie.urbanequestrian.pl/')}
          >
            {buttonText}
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Mission;
